export const truncate = (text, limit = 100) => {
  if (text.length > limit) {
    return text.substring(0, 100) + '...'
  }
  return text
}
export default truncate
